<template>
  <div class="quiz">
    <QuizResult v-if="isFinished"/>
    <QuizCard v-else v-bind="currentCard" @update-card="nextCard"/>
  </div>
</template>

<script>
import QuizCard from './QuizCard.vue'
import QuizResult from './QuizResult.vue'

export default {
  name: 'Quiz',
  components: {
    QuizCard, QuizResult
  },
  data() {
    return {
      currentCardNumber: 0,
    }
  },
  computed: {
    cards: function() {
      return this.$i18n.t('quiz.cards')
    },
    currentCard: function() {
      return this.cards[this.currentCardNumber]
    },
    isFinished: function() {
      return this.currentCardNumber == this.cards.length
    },
  },
  methods: {
    nextCard: function() {
      this.currentCardNumber++
    }
  }
}
</script>

<style scoped lang="scss">
  .quiz {
    max-width: 45rem;
  }
</style>
